<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import SettingsSection from 'dashboard/components/SettingsSection.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const store = useStore();
const { t } = useI18n();

// Mesma chave para TikTok (comentários) e Google (avaliações); só muda o texto.
const isGoogle = computed(() => props.inbox.medium === 'googlebusiness');
const texts = computed(() =>
  isGoogle.value
    ? {
        title: t('INBOX_MGMT.GOOGLE_REVIEW_REPLIES.TITLE'),
        label: t('INBOX_MGMT.GOOGLE_REVIEW_REPLIES.LABEL'),
        help: t('INBOX_MGMT.GOOGLE_REVIEW_REPLIES.HELP_TEXT'),
      }
    : {
        title: t('INBOX_MGMT.TIKTOK_COMMENT_REPLIES.TITLE'),
        label: t('INBOX_MGMT.TIKTOK_COMMENT_REPLIES.LABEL'),
        help: t('INBOX_MGMT.TIKTOK_COMMENT_REPLIES.HELP_TEXT'),
      }
);

const enabled = ref(!!props.inbox.lia_public_comment_replies);
const isSaving = ref(false);

watch(
  () => props.inbox.lia_public_comment_replies,
  value => {
    enabled.value = !!value;
  }
);

const onToggle = async value => {
  isSaving.value = true;
  try {
    await store.dispatch('inboxes/updateInbox', {
      id: props.inbox.id,
      formData: false,
      channel: { lia_public_comment_replies: value },
    });
    useAlert(t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
  } catch (error) {
    enabled.value = !value;
    useAlert(t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'));
  } finally {
    isSaving.value = false;
  }
};

defineExpose({ enabled, onToggle });
</script>

<template>
  <SettingsSection :title="texts.title" :sub-title="texts.help">
    <div class="flex items-center gap-3">
      <Switch
        id="lia-public-comment-replies"
        v-model="enabled"
        :disabled="isSaving"
        @change="onToggle"
      />
      <label
        for="lia-public-comment-replies"
        class="mb-0 text-sm font-medium text-n-slate-12"
      >
        {{ texts.label }}
      </label>
    </div>
  </SettingsSection>
</template>
